<div class="row no-gutters content_top_margin bot_spa_aft_sect_heading">
    <div class="col-12">
        <span class="sectionHeading_one" role="heading" aria-level="2">{{'viewinformation.titleTextBoxPreview'|translate}}</span>
    </div>
</div>
<ng-container *ngFor="let user of userData;let isLast=last;let i=index">
    <div [ngClass]="userData.length>1&&isLast?'row no-gutters bot_spa_aft_sect_heading space_between_section_top':'row no-gutters  bot_spa_aft_sect_heading'"
        *ngIf="userData.length>1">
        <div class="col-12">
                <ng-container *ngIf="user.main_application==0">
                    <span id="applicant" class="sectionHeading_two" role="heading" aria-level="3">

                        {{
                        'information.applicant' | translate }}
                    </span>
                </ng-container>
                <ng-container *ngIf="user.main_application==1">
                    <span id="coapplicant" class="sectionHeading_two" role="heading" aria-level="3">

                        {{
                        'information.coApplicant' | translate }}
                    </span>
                </ng-container>
        </div>
    </div>
    <div class="row no-gutters space_between_section">
        <div class="col-12 cardCls">
            <div class="d-flex borderLine">
                <div class="borderMargin">
                    <span role="heading" class="sectionHeading_three">
                        {{'viewinformation.basicDetails' | translate }}
                    </span>
                </div>
                <div class="ml-3" *ngIf="user.is_existing_bankcustomer=='N'">
                    <button class="infoButton" (click)="routeForEdit('AboutYourselves')"> <img
                            src="./assets/icons/CIBC_Edit.svg" [attr.aria-labelledby]="(i === 0 ? 'applicant' : 'coapplicant') + ' editAboutYourself'"   />
                        <span class="show-for-sr" aria-hidden="true" id="editAboutYourself">{{
                            'viewinformation.editAboutYourself' |
                            translate }}
                        </span>
                    </button>
                </div>
            </div>
            <div class="row no-gutters">
                <div class="col-12 col-md-4 bot_spa_aft_mobile_sec_heading">
                    <small class=" d-flex field_heading_minHeight_label align-items-center  p-0 m-0">
                        <ng-container>{{ 'viewinformation.fname' | translate }}</ng-container>
                    </small>
                    <span>{{user.firstname}}</span>
                </div>
                <div class="col-12 col-md-4 bot_spa_aft_mobile_sec_heading">
                    <small class=" d-flex align-items-center field_heading_minHeight_label   p-0 m-0">
                        <ng-container>{{ 'viewinformation.lname' | translate }}</ng-container>
                    </small>
                    <span>{{user.lastname}}</span>
                </div>
                <div class="col-12 col-md-4 bot_spa_aft_mobile_sec_heading" *ngIf="user.is_existing_bankcustomer=='N'">
                    <small class=" d-flex align-items-center field_heading_minHeight_label  p-0 m-0">
                        <ng-container>{{ 'viewinformation.suffix' | translate }}</ng-container>
                    </small>
                    <span>{{user.suffix}}</span>
                </div>
            </div>
            <div class="row no-gutters top_spa_aft_sect_heading" *ngIf="user.is_existing_bankcustomer=='N'">
                <div class="col-12 col-md-4">
                    <small class=" d-flex align-items-center field_heading_minHeight_label  p-0 m-0">
                        <ng-container>{{ 'viewinformation.dob' | translate }}</ng-container>
                    </small>
                    <span>{{user.date_of_birth | date: 'MM/dd/yyyy'}}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="row no-gutters space_between_section">
        <div class="col-12 cardCls">
            <div class="d-flex borderLine">
                <div class="borderMargin">
                    <span class="sectionHeading_three">{{ 'viewinformation.subtitle2' | translate }}</span>
                </div>
                <div class="ml-3" *ngIf="user.is_existing_bankcustomer=='N'">
                    <button class="infoButton" (click)="routeForEdit('ContactDetails')"> <img
                            src="./assets/icons/CIBC_Edit.svg" [attr.aria-labelledby]="(i === 0 ? 'applicant' : 'coapplicant') + ' editContactDetails'" 
                            aria-hidden="false" />
                        <span class="show-for-sr" aria-hidden="true" id="editContactDetails">{{
                            'viewinformation.editContactDetails' | translate }}
                        </span>
                    </button>
                </div>
            </div>
            <div class="row no-gutters">
                <div class="col-12 col-md-4 bot_spa_aft_mobile_sec_heading">
                    <small class=" d-flex align-items-center field_heading_minHeight_label p-0 m-0">
                        <ng-container>{{ 'viewinformation.phone' | translate }}
                        </ng-container>
                    </small>
                    <span class="readonlyclass">{{ user.mobilenumber }}</span>
                </div>
                <div class="col-12 col-md-6 bot_spa_aft_mobile_sec_heading">
                    <small class=" d-flex align-items-center field_heading_minHeight_label p-0 m-0 pb-1">
                        <ng-container>{{ 'viewinformation.email' | translate }}
                        </ng-container>
                    </small>
                    <span class="text-break">{{user.email}}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="row no-gutters">
        <div class="col-12 cardCls">
            <div class="d-flex borderLine">
                <div class="borderMargin">
                    <span class="sectionHeading_three">
                        {{ 'viewinformation.subtitle3' | translate }}
                    </span>
                </div>
            </div>
            <span class="text-break" [innerHtml]="user.address"></span>
        </div>
    </div>
</ng-container>